import { ActionTypes } from 'redux/utils/Send'

export default ActionTypes('MARKETPLACE_COMMUNITY_SAVING')